
import React, { useState, useEffect } from "react";
import BASE_URL from "../../config";

export default function Dashboard() {

  const [images, setImages] = useState([]);
  const [stats, setStats] = useState({
    team: 0,
    services: 4,
    contacts: 0
  });
// const [user, setUser] = useState(null);

// useEffect(() => {
//   const storedUser = localStorage.getItem("user");
//   if (storedUser) {
//     setUser(JSON.parse(storedUser));
//   }
// }, []);
  // 🔄 Fetch Hero Images
  useEffect(() => {

    const fetchImages = () => {
      fetch(`${BASE_URL}/api/getHero.php?t=${Date.now()}`)
        .then(res => res.json())
        .then(data => setImages(data));
    };

    fetchImages();

    const interval = setInterval(fetchImages, 5000);

    return () => clearInterval(interval);

  }, []);

  // 🔄 Fetch Stats
  useEffect(() => {
   fetch(`${BASE_URL}/api/dashboardStats.php`)
      .then(res => res.json())
      .then(data => setStats(data));
  }, []);

  // 📤 Upload Images
  const handleUpload = (e) => {
    const files = e.target.files;

    const formData = new FormData();

    for (let i = 0; i < files.length; i++) {
      formData.append("images[]", files[i]);
    }

    fetch(`${BASE_URL}/api/uploadHero.php`, {
      method: "POST",
      body: formData
    })
      .then(res => res.text())
      .then(msg => alert(msg));
  };

  // ❌ Delete Image
  const deleteImage = (id) => {
    fetch(`${BASE_URL}/api/deleteHero.php?id=${id}`)
      .then(res => res.text())
      .then(msg => alert(msg));
  };

  return (
    <div className="dashboard">

      {/* PROFILE */}
      {/* <div className="profile-row">
        <div className="profile-left">
          <img src="/images/1.png" alt="admin" />
        </div>

        <div className="profile-right">
          <h2>{user?.name}</h2>
<p><strong>ભૂમિકા:</strong> {user?.role}</p>
<p><strong>ઇમેઇલ:</strong> {user?.email}</p>
<p><strong>મોબાઇલ:</strong> {user?.phone}</p>
        </div>
      </div> */}

      {/* STATS */}
      <div className="stats-grid">

        <div className="stat-card">
          <i className="bi bi-people"></i>
          <h3>{stats.team}</h3>
          <p>કુલ ટીમ સભ્યો</p>
        </div>

        <div className="stat-card">
          <i className="bi bi-briefcase"></i>
          <h3>{stats.services}</h3>
          <p>કુલ સેવાઓ</p>
        </div>

        <div className="stat-card">
          <i className="bi bi-telephone"></i>
          <h3>{stats.contacts}</h3>
          <p>સંપર્કો</p>
        </div>

      </div>

      {/* HERO IMAGE MANAGER */}
      <div className="hero-admin">

        <h3>હીરો સ્લાઇડર ઈમેજ ઉમેરો</h3>

        <input
          type="file"
          multiple
          accept="image/*"
          onChange={handleUpload}
        />

        <div className="hero-preview">
          {images.length === 0 ? (
            <p>કોઈ ઈમેજ નથી</p>
          ) : (
            images.map((img) => (
              <div key={img.id} style={{ position: "relative" }}>
                <img 
                  src={`${BASE_URL}/uploads/${img.image}`}
                  width="150"
                />
                <button onClick={() => deleteImage(img.id)}>❌</button>
              </div>
            ))
          )}
        </div>

      </div>

    </div>
  );
}